export default __webpack_public_path__ + "static/mainlogo-d6481c0efe5fdb45536134bb492210a9.png";